import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import classNames from 'classnames';
import React__default from 'react';
import { createPortal } from 'react-dom';
import { getPrefixCls } from '../../utils/getPrefix.js';
import { IconCrossSmall } from '../Icon/IconCrossSmall.js';
import '../../extends-30811c5e.js';
import '../../objectWithoutProperties-dd908bcc.js';

var prefixCls = getPrefixCls('modal');
var Modal = function Modal(_ref) {
  var className = _ref.className,
    _ref$attachTo = _ref.attachTo,
    attachTo = _ref$attachTo === void 0 ? document.getElementById('app') || document.body : _ref$attachTo,
    children = _ref.children,
    onClose = _ref.onClose,
    onClickOutside = _ref.onClickOutside,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'modal' : _ref$dataTestid,
    _ref$fullscreen = _ref.fullscreen,
    fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    _ref$dark = _ref.dark,
    dark = _ref$dark === void 0 ? false : _ref$dark;
  var handleClose = function handleClose(e) {
    onClose === null || onClose === void 0 || onClose(e);
  };
  var modalContent = /*#__PURE__*/React__default.createElement("div", {
    "sl-test-data": dataTestid,
    className: classNames(prefixCls, className, _defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-fullscreen"), fullscreen), "".concat(prefixCls, "-noPadding"), noPadding), "".concat(prefixCls, "-dark"), dark))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_overlay"),
    "sl-test-data": "modalOverlay",
    onClick: onClickOutside || handleClose
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_content")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_close")
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "".concat(prefixCls, "_closeButton"),
    "sl-test-data": "modalClose",
    onClick: handleClose,
    "aria-label": "Close"
  }, /*#__PURE__*/React__default.createElement(IconCrossSmall, null))), children));
  return attachTo ? /*#__PURE__*/createPortal(modalContent, attachTo) : modalContent;
};

export { Modal };
